import { render, staticRenderFns } from "./ModalAjoutProduits.vue?vue&type=template&id=258dd0c8&"
import script from "./ModalAjoutProduits.vue?vue&type=script&lang=js&"
export * from "./ModalAjoutProduits.vue?vue&type=script&lang=js&"
import style0 from "./ModalAjoutProduits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258dd0c8')) {
      api.createRecord('258dd0c8', component.options)
    } else {
      api.reload('258dd0c8', component.options)
    }
    module.hot.accept("./ModalAjoutProduits.vue?vue&type=template&id=258dd0c8&", function () {
      api.rerender('258dd0c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Commandes/ModalAjoutProduits.vue"
export default component.exports